import copy from "clipboard-copy";

const CopyField = ({ label, value }) => (
  <div className="row">
    <p className="mobile-hidden">{label}</p>
    <div className="only-show-mobile">
      <p>{label}</p>
    </div>
    <div style={{ display: "flex", alignItems: "center", gap: "0.8rem" }}>
      <code style={{ fontSize: "0.85em", wordBreak: "break-all" }}>
        {value}
      </code>
      <button
        type="button"
        data-button-type="secondary"
        data-icon
        data-icon-only
        onClick={async () => {
          await copy(value);
        }}
      >
        <img src="/img/new-icons/copy.svg" alt="Copy" />
      </button>
    </div>
  </div>
);

export default CopyField;
